import React from 'react';
import PropTypes from 'prop-types';
import { ForgeCard } from '@tylertech/forge-react';

const AIAnalysisCard = ({ data, className }) => {
  return (
    <ForgeCard className={`safari-card-flex ${className}`}>
      <div className="flexContainer direction-column">
        <div className="forge-typography--body1">{data}</div>
      </div>
    </ForgeCard>
  );
};
AIAnalysisCard.propTypes = {
  data: PropTypes.string,
  className: PropTypes.string,
};
export default AIAnalysisCard;
